export const config = {
    type: 'BOTTOM_BUTTON',
    title: '底部按钮',
    defaultProps: {
        text: '立即加入',
        textColor: '#fff',
        fontSize: '16',
        link: '',
        animation: 'none',
        backgroundColor: '#0064fa',
        width: '80',
        height: '40',
        borderRadius: '20',
        bottom: '20'
    },
    preview: {
        style: {
            padding: '8px',
            display: 'flex',
            justifyContent: 'center'
        },
        button: {
            style: {
                width: '120px',
                height: '32px',
                background: 'var(--semi-color-primary-light-default)',
                borderRadius: '16px'
            }
        }
    }
};